module.exports = {"title":"PRIVACY POLICY","sub_title":"プライバシーポリシー","description":"株式会社 J・L・Nのプライバシーポリシーページです","canonical":"/privacypolicy/"}


//////////////////
// WEBPACK FOOTER
// ./src/config/privacy_policy.json
// module id = 542
// module chunks = 0